import type { Progress } from '../types';

interface Props {
    progress: Progress;
    showLabel?: boolean;
}

export function ProgressBar({ progress, showLabel = true }: Props) {
    const { total, completed, in_progress, blocked, skipped } = progress;
    if (total === 0) return null;

    const completedPct = (completed / total) * 100;
    const skippedPct = (skipped / total) * 100;
    const inProgressPct = (in_progress / total) * 100;
    const blockedPct = (blocked / total) * 100;

    return (
        <div className="space-y-1">
            <div
                className="flex h-2.5 w-full overflow-hidden rounded-full bg-gray-100"
                role="progressbar"
                aria-valuenow={progress.percent}
                aria-valuemin={0}
                aria-valuemax={100}
                aria-label={`${completed + skipped} of ${total} steps complete (${progress.percent}%)`}
            >
                {completedPct > 0 && (
                    <div
                        className="bg-emerald-500 transition-all"
                        style={{ width: `${completedPct}%` }}
                    />
                )}
                {skippedPct > 0 && (
                    <div
                        className="bg-gray-300 transition-all"
                        style={{ width: `${skippedPct}%` }}
                    />
                )}
                {inProgressPct > 0 && (
                    <div
                        className="bg-blue-400 transition-all"
                        style={{ width: `${inProgressPct}%` }}
                    />
                )}
                {blockedPct > 0 && (
                    <div
                        className="bg-red-400 transition-all"
                        style={{ width: `${blockedPct}%` }}
                    />
                )}
            </div>
            {showLabel && (
                <p className="text-xs text-muted-foreground" aria-hidden="true">
                    {completed + skipped}/{total} complete ({progress.percent}%)
                </p>
            )}
        </div>
    );
}